export default {
  user: undefined,
  mainOptions: null,
  dropdownOptions: [
    { Name: 'Illness', options: ['Flu', 'COPD', 'Misc'] },
    { Name: 'Contraceptives', options: ['option1', 'option2', 'option3'] },
    { Name: 'Other', options: ['other1', 'other2', 'other3'] },
  ],
  dropdownList: null,
  dropdownMainSelected: null,
  dropdownSubSelected: null,
  dropdownIndex: null,
  teststate: 'dsa',
  SelectedOption: 'Select Catagory',
  MainOptionSelected: '',
  propertylist: [],
  latestkitlist: [],
  subCatInfo: {},
  subCatSelected: { name: 'Please Select a Subcatagory' },
  mainCatSelected: { name: 'Please Select a Category' },
  msgSent: false,
};
